import { Card, CardHeader } from '@material-ui/core';
import ReactTooltip from 'react-tooltip';
import CalendarHeatmap from 'react-calendar-heatmap';
import 'react-calendar-heatmap/dist/styles.css';
import moment from 'moment';
import React from 'react';
import { useNavigate } from 'react-router';
import { createSearchParams } from 'react-router-dom';

export default function HeatMap({ requestsSummary }) {
  const today = new Date();
  const yearBefore = new Date();
  yearBefore.setMonth(yearBefore.getMonth() - 12);
  const navigate = useNavigate();
  return (
    <Card style={{ padding: '20px' }}>
      <CardHeader title={`Requests`} subheader="In the last year" />
      <CalendarHeatmap
        startDate={moment(yearBefore).format('YYYY-MM-DD')}
        endDate={moment(today).format('YYYY-MM-DD')}
        onClick={(value) => {
          //filterColumn=createdAt&filterOperation=equals&filterValue=2023-08-22
          navigate({
            pathname: '/dashboard/requests',
            search: `?${createSearchParams({
              filterColumn: 'createdAt',
              filterOperation: 'equals',
              filterValue: value.date
            })}`
          });
        }}
        tooltipDataAttrs={(value) => {
          if (value.date)
            return {
              'data-tip': `${value.count} ${value.count > 1 ? 'requests' : 'request'} on ${
                value.date
              }`
            };
        }}
        classForValue={(value) => {
          if (!value) {
            return 'color-empty';
          }
          return `color-github-${value.count}`;
        }}
        // Here I accumulate objects with same creation date
        // then returning new object for each date includes that date
        // and requests made on it.
        values={Object.entries(
          requestsSummary.reduce((a, c) => {
            a[moment(c.created_at_date).format('YYYY-MM-DD')] =
              (a[moment(c.created_at_date).format('YYYY-MM-DD')] || 0) + 1;
            return a;
          }, {})
        ).map((arr) => {
          const [date, count] = arr;
          return {
            date,
            count
          };
        })}
      />
      <ReactTooltip />
    </Card>
  );
}
